module.exports = __webpack_public_path__ + "fonts/EuclidSquare-SemiBold.woff2";